import { render, staticRenderFns } from "./managerWordList.vue?vue&type=template&id=74dbb9b6"
import script from "./managerWordList.vue?vue&type=script&lang=js"
export * from "./managerWordList.vue?vue&type=script&lang=js"
import style0 from "./managerWordList.vue?vue&type=style&index=0&id=74dbb9b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports